module.exports = __webpack_public_path__ + "static/media/close.496569ed.svg";